<style type="text/css" media="screen">

.comment-list .v-list-item{
	min-height: 28px !important;
}
.comment-list-block{
	height: 150px;
	max-height: 150px;
	overflow-y: scroll; 
}

</style>

<template>
	<div class=" mt-15 pb-5">
		<p class="sub-title-text-dark mb-5">{{$lang.COMMENTS}}</p>
		<div v-if="ticket_details.status==$keys.OPEN">
			<v-form ref="comment_form"  lazy-validation @submit.prevent="addComment()">
				<v-text-field
				:label="$lang.TYPE_COMMENT"
				single-line
				outlined
				dense
				hide-details
				rounded
				maxlength="200"
				v-model="comment_text"
				:rules="[v => !!v || 'Type something']"
				style="background-color:#ffff"
				>
				<template slot="append">
					<v-btn class="custom-btn pa-0"
					text 
					color="primary" 
					style="margin-top:-6px;margin-right:-10px"
					type="submit"
					:loading="btn_loading"
					>
					{{$lang.ADD}}
				</v-btn>
			</template>
		</v-text-field>
	</v-form >

</div>
<div class="mt-5 pl-2">
	<div v-if="comment_list.length==0" >
		<p class="comment-date-text ">{{$lang.EMPTY_COMMENT}}</p> 
	</div>
	<div >
		<div  v-for="(comment,i) in comment_list" :key="i"  class="comment-list mb-3" >

			<v-row justify="center">
				<v-col cols="12" md="2">
					<v-avatar size="45px" color="primary">
						<span class="white--text  fs-18 fw-bold">{{comment.commented_by.substring(0, 2).toUpperCase()}}</span>
					</v-avatar>
				</v-col>
				<v-col cols="12" md="10">
					<p class="comment-date-text ">{{comment.created}}</p> 
					<p class="sub-title-text fs-15 my-1">{{comment.commented_by}}</p>
					<p class="secondary-text">{{comment.comment_text}}</p>
				</v-col>
			</v-row>


			<!-- <p class="comment-date-text ">{{comment.created}}</p>  -->
			<!-- <p class="sub-title-text fs-15 my-1">{{comment.commented_by}}:</p> -->
				<!-- <v-list-item class="px-0">
					<v-list-item-icon class="sub-title-text fs-15 my-1">
						{{comment.commented_by}} : 
					</v-list-item-icon>
					<v-list-item-content class="py-0">
						<p class="secondary-text">{{comment.comment_text}}</p>
					</v-list-item-content>
				</v-list-item> -->
			</div>
		</div>
	</div>
</div>
</template>
<script type="text/javascript">
export default {
	props:["comment_list",'ticket_id','ticket_details'],
	data(){
		return{
			comment_text:"",
			btn_loading:false
		}
	},
	methods:{
		addComment(){
			if (this.$refs.comment_form.validate()==false)
				return false

			if (!this.	comment_text)
				return false
			
			this.btn_loading=true

			const self=this;
			var	form = new FormData();
			form.append("ticket_id",self.ticket_id);
			form.append("comment_text",self.comment_text);

			const successHandler = (response) => {
				console.log(response)
				if (response.data.success){
					self.comment_text="";
					this.$refs.comment_form.reset()

					this.$emit("update-comment-list", response.data.comment_list.reverse());

				}
			};
			const finallyHandler = () => {
				self.btn_loading=false
			};
			
			this.request_POST(self,this.$urls.ADD_COMMENT,form,successHandler,null,null,finallyHandler)





		}
	}
}



</script>